import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import { reducer as formReducer } from 'redux-form';

// import reducers from connected features, add them to the combined root reducer below
import { reducer as BrandInfoReducer } from './domain/BrandInfo';
import { reducer as BreadcrumbsReducer } from './domain/Breadcrumbs';
import { reducer as CartReducer } from './domain/Cart';
import { reducer as DialogReducer } from './domain/Dialog';
import { reducer as CategoriesReducer } from './domain/Categories';
import { reducer as NavBarReducer } from './domain/NavBar';
import { reducer as NotificationReducer } from './domain/Notification';
import { reducer as ProductFilterReducer } from './domain/ProductFilter';
import { reducer as ProductModalReducer } from './domain/ProductModal';
import { reducer as ProductReducer } from './domain/Product';
import { reducer as ProductSearchReducer } from './domain/ProductSearch';
import { reducer as StoreLocationReducer } from './domain/StoreLocation';
import { reducer as SubCategoriesReducer } from './domain/SubCategories';
import { reducer as UserReducer } from './domain/User';

const reducers = combineReducers({
	brandInfo: BrandInfoReducer,
	breadcrumbs: BreadcrumbsReducer,
	cart: CartReducer,
	categories: CategoriesReducer,
	routing: routerReducer,
	form: formReducer,
	dialog: DialogReducer,
	navbar: NavBarReducer,
	notification: NotificationReducer,
	product: ProductReducer,
	productFilter: ProductFilterReducer,
	productModal: ProductModalReducer,
	productSearch: ProductSearchReducer,
	storeLocation: StoreLocationReducer,
	subCategories: SubCategoriesReducer,
	user: UserReducer,
});

export default reducers;
